/**
 * Set (bundle) availability for surfaces that render product cards from JSON.
 *
 * Boost, the recommendations carousel and quick add all build their markup on
 * the client from Shopify/Boost JSON, which carries no metafields — so they
 * cannot use snippets/bundle-availability.liquid. They read the precomputed map
 * that theme.liquid inlines into window.__bundleAvailability instead:
 *
 *   { "<product_id>": { "q": <available sets>, "s": "ok" | "out" } }
 *
 * Products missing from the map fail closed to "error" ("temporarily
 * unavailable", purchase blocked) per spec. Products without the isBundle tag
 * are never touched and keep stock Shopify behaviour.
 */
(function () {
  // Exact match required: 'isbundle' is a different tag and must not trigger set logic.
  var BUNDLE_TAG = 'isBundle';

  function map() {
    return window.__bundleAvailability || {};
  }

  function isBundle(product) {
    return !!product && Array.isArray(product.tags) && product.tags.indexOf(BUNDLE_TAG) !== -1;
  }

  /** 'normal' | 'ok' | 'out' | 'error' */
  function state(product) {
    if (!isBundle(product)) return 'normal';

    var entry = map()[String(product.id)];
    if (!entry || typeof entry.q !== 'number' || (entry.s !== 'ok' && entry.s !== 'out')) {
      return 'error';
    }

    return entry.q > 0 ? 'ok' : 'out';
  }

  /** Available sets; 0 for every non-purchasable state. */
  function quantity(product) {
    if (state(product) !== 'ok') return 0;
    return map()[String(product.id)].q;
  }

  function isPurchasable(product) {
    var current = state(product);
    if (current === 'normal') return !!(product && product.available);
    return current === 'ok';
  }

  /** Text for the disabled button / price slot. Empty while purchasable. */
  function unavailableLabel(product) {
    var buttons = (window.Shopify && window.Shopify.buttons) || {};
    var current = state(product);

    if (current === 'error') return buttons.temporarilyUnavailable || 'Temporarily unavailable';
    if (current === 'out' || (current === 'normal' && !isPurchasable(product))) {
      return buttons.soldOut || 'Sold out';
    }
    return '';
  }

  /**
   * True when the product should not be listed at all (grids, carousels,
   * recommendation strips). A set that is cleanly sold out drops off the same
   * way an ordinary out-of-stock product does; 'error' keeps its disabled card
   * so a failed sync never empties the catalogue.
   */
  function isHiddenFromFeeds(product) {
    var current = state(product);
    if (current === 'out') return true;
    if (current === 'normal') return !(product && product.available);
    return false;
  }

  window.BundleAvailability = {
    isBundle: isBundle,
    state: state,
    quantity: quantity,
    isPurchasable: isPurchasable,
    unavailableLabel: unavailableLabel,
    isHiddenFromFeeds: isHiddenFromFeeds,
  };
})();
